import React from "react";

const LeftArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="55"
      height="33"
      viewBox="0 0 55 33"
    >
      <path
        d="M14.777,2.924a2,2,0,0,1,3.446,0l13,22.061A2,2,0,0,1,29.5,28H3.5a2,2,0,0,1-1.723-3.015Z"
        transform="translate(27 33) rotate(-90)"
        fill="#00ad67"
      />
      <path
        d="M14.777,2.924a2,2,0,0,1,3.446,0l13,22.061A2,2,0,0,1,29.5,28H3.5a2,2,0,0,1-1.723-3.015Z"
        transform="translate(0 33) rotate(-90)"
        fill="#00ad67"
      />
    </svg>
  );
};

export default LeftArrow;
